
import React, { useState } from 'react';
import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import InfoBtn from '../../images/info-btn.svg';
import NasiontoInionModal from './NasiontoInionModal';
import PreauricularModal from './PreauricularModal';
import CircumferenceModal from './CircumferenceModal';

const FormCardResults = ({ onFormSubmit, formData, onReset }) => {
  const [localFormData, setLocalFormData] = useState({
    nasionToInion: formData.nasionToInion || '35',
    preauricular: formData.preauricular || '35',
    circumference: formData.circumference || '35',
    nomenclature: formData.nomenclature || 'T3/T4',
  });
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);

  const handleChange = (id, value) => {
    setLocalFormData({ ...localFormData, [id]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onFormSubmit(localFormData);
  };

  const resetForm = () => {
    setLocalFormData({
      nasionToInion: '',
      preauricular: '',
      circumference: '',
      nomenclature: 'T3/T4',
    });
    onReset();
  };

  return (
    <div className="login-box homepage-form">
      <div className="head-info">
        <p>
          You can update the parameters and click on “Update Result” to recalculate the interelectrode distances for this EEG.
        </p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="form-field">
          <div className="label-part d-flex align-items-center w-100 justify-content-between">
            <label htmlFor="nasionToInion" className="w-100">
              Nasion to Inion distance
            </label>
            <Link
              href=""
              onClick={(e) => {
                e.preventDefault();
                setShowModal(true);
              }}
            >
              <Image src={InfoBtn} alt="" />
            </Link>
          </div>
          <div className="distance-input position-relative d-flex align-items-center w-100">
            <input
              type="text"
              className="input-field active-input"
              id="nasionToInion"
              placeholder="--"
              value={localFormData.nasionToInion || ''}
              onChange={(e) => handleChange('nasionToInion', e.target.value)}
            />
            <span className="unit-label">cm</span>
          </div>
        </div>
        <div className="form-field">
          <div className="label-part d-flex align-items-center w-100 justify-content-between">
            <label htmlFor="preauricular" className="w-100">
              Preauricular to Preauricular distance
            </label>
            <Link
              href=""
              onClick={(e) => {
                e.preventDefault();
                setShowModal2(true);
              }}
            >
              <Image src={InfoBtn} alt="" />
            </Link>
          </div>
          <div className="distance-input position-relative d-flex align-items-center w-100">
            <input
              type="text"
              className="input-field active-input"
              id="preauricular"
              placeholder="--"
              value={localFormData.preauricular || ''}
              onChange={(e) => handleChange('preauricular', e.target.value)}
            />
            <span className="unit-label">cm</span>
          </div>
        </div>
        <div className="form-field">
          <div className="label-part d-flex align-items-center w-100 justify-content-between">
            <label htmlFor="circumference" className="w-100">
              Circumference
            </label>
            <Link
              href=""
              onClick={(e) => {
                e.preventDefault();
                setShowModal3(true);
              }}
            >
              <Image src={InfoBtn} alt="" />
            </Link>
          </div>
          <div className="distance-input position-relative d-flex align-items-center w-100">
            <input
              type="text"
              className="input-field active-input"
              id="circumference"
              placeholder="--"
              value={localFormData.circumference || ''}
              onChange={(e) => handleChange('circumference', e.target.value)}
            />
            <span className="unit-label">cm</span>
          </div>
        </div>
        <div className="form-field">
          <label htmlFor="nomenclature">Preferred Nomenclature</label>
          <div className="custom-dropdown dropdown w-100 position-relative">
            <a
              className="dropdown-toggle form-like-dropdown d-flex align-items-center justify-content-between"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {localFormData.nomenclature}
              <span className="custom-dropdown-arrow">
                <svg
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.8334 1.5L7.00008 6.5L1.16675 1.5"
                    stroke="#838383"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </a>
            <ul className="dropdown-menu w-100">
              {['T3/T4', 'T7/T8'].map((item) => (
                <li key={item}>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setLocalFormData({ ...localFormData, nomenclature: item });
                    }}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <a href="#" className="forgot-password mt-2" onClick={(e) => { e.preventDefault(); resetForm(); }}>
          Reset Form
        </a>
        <div className="form-footer mt-4">
          <button type="submit" className="login-button btn-light">
            Generate Result
          </button>
        </div>
      </form>
      <NasiontoInionModal showModal={showModal} onClose={() => setShowModal(false)} />
      <PreauricularModal showModal2={showModal2} onClose={() => setShowModal2(false)} />
      <CircumferenceModal showModal3={showModal3} onClose={() => setShowModal3(false)} />
    </div>
  );
};

export default FormCardResults;
